module.exports = __webpack_public_path__ + "media/images/vonblon.power-9bcf1453.svg";